import { Component, DestroyRef, inject, ElementRef, HostListener, Inject, OnInit, ViewChild} from '@angular/core';
import {  MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseComponent } from 'src/app/base/base.component';
import { ColoredNumberFindReplaceItem, ColoredTextItem, NamedColorList } from 'src/app/domainObjects/coloredTextItem';
import { NamedColor } from 'src/app/domainObjects/namedColor';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { KeyboardService } from 'src/app/services/keyboard/keyboard.service';

class ViewModel {
  colors: NamedColor[];
  textItems: ColoredNumberFindReplaceItem[] = [];
  currentColor: NamedColor;
  find: number;
  replace: number;
  sourceItems: ColoredTextItem[] = [];

  constructor(items: ColoredNumberFindReplaceItem[],sourceItems: ColoredTextItem[]) {

    const itemsCopy = items.map(r => new ColoredNumberFindReplaceItem(r.find,r.replace, r.color)) ?? [];

    this.textItems = itemsCopy ?? [];
    this.colors = NamedColorList;
    const maxlength = this.colors.length;
    let nextlength = this.textItems.length+1;
    var nextIndex=nextlength-1;
    if (nextlength > maxlength) {
      var rem = (nextlength%maxlength);
      if(rem==0){
        nextIndex=maxlength-1;
      }
      else{
        nextIndex=rem-1;
      }
    }
    this.currentColor = this.colors[nextIndex];
    const sourceItemsCopy = sourceItems.map(r => new ColoredTextItem(r.text, r.color)) ?? [];
        this.sourceItems = sourceItemsCopy ?? [];
  }
}

@Component({
    selector: 'app-range-entry-field',
    templateUrl: './range-entry-field.component.html',
    styleUrls: ['./range-entry-field.component.css'],
    standalone: false
})
export class RangeEntryFieldComponent extends BaseComponent implements OnInit{
  private readonly destroyRef = inject(DestroyRef);
  title: string="Range Entry";
  symbol: string=">";
  isShowHeader: boolean = true;
  isAddNew: boolean = true;
  enterKeyPressCount: number = 0;  // Counter for Enter key presses
  findLabel: string="Start";
  replaceLabel: string="End";
  findPlaceholder: string="Enter Start Range";
  replacePlaceholder: string="Enter End Range";
  isSpinner: boolean = true;
  isPositiveInteger: boolean = false;

  viewModel: ViewModel;
  @ViewChild('textbox') textbox: ElementRef;
  @ViewChild('textboxmatformfind', { read: ElementRef }) textboxmatformfind: ElementRef;
  @ViewChild('textboxmatformreplace', { read: ElementRef }) textboxmatformreplace: ElementRef;

  constructor(
    private dialogRef: MatDialogRef<RangeEntryFieldComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData,
    errorLogger: ErrorReportingService,
     private keyboardService: KeyboardService,
    matDialog: MatDialog) {
      super(errorLogger, matDialog);
  }
  @HostListener('document:keydown.escape')
    onEscapePress() {
      this.cancel();
    }
    ngOnInit(): void {
      if(this.dialogData.title!=undefined){
        this.title = this.dialogData.title;
      }
      if(this.dialogData.symbol!=undefined){
        this.symbol = this.dialogData.symbol;
      }
      if(this.dialogData.isShowHeader!=undefined){
        this.isShowHeader = this.dialogData.isShowHeader;
      }
      if(this.dialogData.isAddNew!=undefined){
        this.isAddNew = this.dialogData.isAddNew;
      }
      if(this.dialogData.findLabel!=undefined){
        this.findLabel = this.dialogData.findLabel;
      }
      if(this.dialogData.replaceLabel!=undefined){
        this.replaceLabel = this.dialogData.replaceLabel;
      }
      if(this.dialogData.findPlaceholder!=undefined){
        this.findPlaceholder = this.dialogData.findPlaceholder;
      }
      if(this.dialogData.replacePlaceholder!=undefined){
        this.replacePlaceholder = this.dialogData.replacePlaceholder;
      }
      if(this.dialogData.isSpinner!=undefined){
        this.isSpinner = this.dialogData.isSpinner;
      }
      if(this.dialogData.isPositiveInteger!=undefined){
        this.isPositiveInteger = this.dialogData.isPositiveInteger;
      }

      this.viewModel = new ViewModel(this.dialogData.items,this.dialogData.sourceItems);
      this.viewModel.find=0;
      this.viewModel.replace=1;
    }
      ngAfterViewInit(): void {
    // Focus out from the textbox after view initialization
   
    this.keyboardService.onKey('Escape', () => {
    this.cancel();
  }, this.destroyRef);
  this.keyboardService.registerEnterToDelete(
    () => this.viewModel.textItems,
    (item) => this.deleteItem(item),
    '#add-input', // 🔥 fallback focus
    this.destroyRef
  );
  //   this.keyboardService.registerArrowNavigation(
  //   this.dialogRoot.nativeElement
  // );
  this.keyboardService.registerGlobalDoubleEnter(() => {
  this.save();
}, this.destroyRef);
  
  }
    save(): void {
      var isValid=true;
      // Check if find field is empty
      this.viewModel.textItems.forEach((item, index) => {
        if(item.find==null){
          isValid=false;
          return;
        }
        if(item.replace==null){
          isValid=false;
          return;
        }
        if(Number(item.find) >= Number(item.replace)){
          isValid=false;
          return;
        }
      });
      if(!isValid){
        this.displayWarning("No entries can be empty or first value is less than the second value, please enter value.","Warning.");
        return;
      }
      this.dialogRef.close({items: this.viewModel.textItems,eventname:'save'});
    }
  
    cancel(): void {
      this.dialogRef.close({items: this.viewModel.textItems,eventname:'cancel'});
    }
    focusNext(nextIndex: number) {
      const nextInput = document.getElementById('findInput' + nextIndex);
      if (nextInput) {
        (nextInput as HTMLInputElement).focus();  // Focus on the next input
      }
    }
    addItem(): void {
      if(this.viewModel.find==null){
        this.textboxmatformfind.nativeElement.classList.add('mat-form-field-invalid');
      }
      if(this.viewModel.replace==null){
        this.textboxmatformreplace.nativeElement.classList.add('mat-form-field-invalid');
        this.enterKeyPressCount++;  // Increment Enter key press counter
        if (this.enterKeyPressCount >= 2) {
          this.save();
        }
        return;
      }
      if(Number(this.viewModel.find) >= Number(this.viewModel.replace)){
        this.displayWarning("No entries can be empty or first value is less than the second value, please enter value.","Warning.");
        return;
      }
      // Reset error state if input is valid
      this.textboxmatformfind.nativeElement.classList.remove('mat-form-field-invalid');
      this.textboxmatformreplace.nativeElement.classList.remove('mat-form-field-invalid');
      this.enterKeyPressCount = 0;
      const item = new ColoredNumberFindReplaceItem(this.viewModel.find,this.viewModel.replace, this.viewModel.currentColor);
      this.viewModel.textItems.push(item);
  
      const maxlength = this.viewModel.colors.length;
      let nextlength = this.viewModel.textItems.length+1;
      var nextIndex=nextlength-1;
      if (nextlength > maxlength) {
        var rem = (nextlength%maxlength);
        if(rem==0){
          nextIndex=maxlength-1;
        }
        else{
          nextIndex=rem-1;
        }
      }
      this.viewModel.currentColor = this.viewModel.colors[nextIndex];
      // this.viewModel.find="";
      // this.viewModel.replace="";
      //this.textbox.nativeElement.focus();
    }
    deleteItem(item: ColoredNumberFindReplaceItem): void {
      const index = this.viewModel.textItems.indexOf(item);
      this.viewModel.textItems.splice(index, 1);
      //this.textbox.nativeElement.focus();
      this.reAssignColor();
    }
    reAssignColor(): void {
      let colorIndex = 0;
      this.viewModel.textItems.forEach(item=>{
        item.color=NamedColorList[colorIndex++];
      });
      this.viewModel.currentColor=NamedColorList[colorIndex++];
    }
}
